import { commands } from './Commands';
import { componentMenuGroups } from './ComponentMenuGroups';

export const commandGroups = [
    {
        name: strings.commandGroups.actions,
        items: [
            commands.save,
            commands.saveAll,
            null,
            commands.recentItems,
            null,
            commands.zoom,
            null,
            commands.refreshEditor,
            null,
            commands.copy,
            commands.paste,
            null,
            commands.createSubProcess,
            commands.deleteSubProcess,
            null,
            commands.undo,
            commands.redo,
            null,
            null,
            commands.preview,
            commands.openInViewer,
            null,
            commands.schedule,
            commands.unschedule,
            null,
            commands.refreshDataLoads,
            commands.cancelDataLoads,
            commands.resumeDataLoads,
            null,
            commands.addRecordDate,
            commands.removeSelectedDate,
            commands.refreshRecordDates,
            null,

            commands.startSchedulerLog,
            commands.stopSchedulerLog,
            null,
            commands.refreshSchedulerLog,
            null,
            commands.turnOnEditMode,
            commands.turnOffEditMode,
            null,
            commands.changePassword,
            commands.tenantsUpdate,
            commands.tenantsUpgrade
        ]
    },
    {
        name: strings.commandGroups.view,
        items: componentMenuGroups
    },
    {
        name: strings.commandGroups.design,
        items: [
            commands.showAnchors,
            commands.deleteComponents,
            commands.autoAnchors,
            commands.deleteAnchors,
            commands.snapToGrid,
            commands.blackCanvas,
            commands.sendToBack,
            commands.bringToFront,
            commands.reorderHorizontal,
            commands.reorderVertical
        ]
    },
    {
        name: strings.commandGroups.tools,
        items: [
            commands.studioSettings,
            commands.filterGroups,
            commands.exportProjectDocuments,
            commands.exportProjectDocumentsToSourceFolder,
            commands.importProjectDocuments,
            commands.specifiedColors,
            commands.resaveAll,
            commands.fixReferences,
            commands.openDimensionManager,
            null,
            commands.publish,
            commands.publishAndRebuild,
            null,
            commands.updateAllProjects,
            commands.importSolutions,
            commands.generateLocalizationTables,
            null,
            commands.editTheme,
            null,
            commands.toggleTestSession,
            commands.getLogs,
            null,
            commands.generateRModel,
            null,
            commands.projectMode
        ]
    }
];
